var _Circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Circle } from "react-native-svg";
function SvgIconRecording(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 299,
    cy: 916,
    r: 6,
    fill: "#FF3129",
    transform: "translate(-293 -910)",
    fillRule: "evenodd"
  })));
}
export default SvgIconRecording;